import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchAuditLogs } from '@/api/audit/auditApi';
import type { AuditLogEntry, AuditLogQuery } from '@/api/audit/auditApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import { AUDIT_LOGS_QUERY_KEY } from '@/constants/queryKeys';

export function useAuditLogsQuery(
  query: AuditLogQuery,
  tenantId?: string
): UseQueryResult<PaginatedResult<AuditLogEntry>, Error> {
  return useQuery({
    queryKey: [...AUDIT_LOGS_QUERY_KEY, tenantId === undefined ? null : tenantId, query],
    queryFn: function loadAuditLogs() {
      return fetchAuditLogs(query, tenantId);
    },
    placeholderData: keepPreviousData,
  });
}
